"use client"

import AwesomeCard from "@/components/common/awesome-card";
import VerticalTimeline, { TimelineItem } from "@/components/common/vertical-timeline/vertical-timeline";


const items: TimelineItem[] = [
    {
      id: "story-60f7602",
      position: "right",
      title: "Le meilleur de la nature",
      description: "Ressentez l'énergie de ce paradis vert, et laissez-vous tenter que vous soyez amateur, amoureux ou spécialiste de la nature vierge.",
      imageUrl: "/images/remplissez-vos-jours-de-vie/meilleur-de-la-nature.jpg",
      alt: "Image de nature en Côte d'Ivoire"
    },
    {
      id: "story-798163b",
      position: "left",
      title: "S'imprégner de la culture",
      description: "Chacun de vos pas lors de votre visite vous ouvre la porte sur une partie de l'émouvante histoire de notre pays.",
      imageUrl: "/images/remplissez-vos-jours-de-vie/simpregner-de-la-culture.jpg",
      alt: "Image culturelle de Côte d'Ivoire"
    },
    {
      id: "story-60bdf2f",
      position: "right",
      title: "Explorez le pays",
      description: "Inspirante terre d'hospitalité, aucune autre destination ne peut faire voyager autant tous vos sens au cours d'un seul voyage.",
      imageUrl: "/images/remplissez-vos-jours-de-vie/meilleur-de-la-nature.jpg",
      alt: "Image d'exploration en Côte d'Ivoire"
    }
  ];

export default function RemplissezVosJoursDeVie() {
    return <AwesomeCard title={"Remplissez vos jours de vie"} className={"bg-parc-national-tai bg-center bg-cover"} titleClassName={"text-bleu-marine"}>
        <VerticalTimeline items={items} />
        </AwesomeCard>;
}
